import React from 'react';
import { useParams } from '@thd-olt-component-react/router';
import {
  Card, CardContent, CardBody, Typography, Link
} from '@one-thd/sui-atomic-components';
import {
  arrayOf as arrayOfType,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { StoreHours } from './StoreHours';
import { convertToTitleCase } from './localCityUtils';

const lcpMetricsQueryParam = '?emt_lcpq2';

export const LocalCityStorePod = () => {
  const { state, city, guid } = useParams();

  const { data, error, loading } = useDataModel('storeSearch', {
    variables: {
      guid,
      radius: '75',
    }
  });

  if (!(data && data?.storeSearch?.stores) || loading || error) return null;

  const formatCity = convertToTitleCase(city);
  const formatState = state.toUpperCase();

  return (
    <div>
      <Typography variant="h2" weight="display" height="snug" color="primary">
        {`Stores in the ${formatCity}, ${formatState} Area`}
      </Typography>
      <div
        className="sui-relative box-border sui-gap-4 sui-grid lg:sui-grid-cols-4
      md:sui-grid-cols-2 sm:sui-grid-cols-1 sui-overflow-hidden sui-w-full"
        id="js-results"
        data-component="LocalCityStorePod"
      >
        {data?.storeSearch?.stores?.map((store, index) => (
          <div key={store?.storeId} className="sui-mb-3" data-testid="store-search-pod-testId">
            <Card className="sui-h-full" id={`podCardId${index}`}>
              <CardContent disablePadding grow>
                <CardBody>
                  <div className="sui-pt-1 sui-pb-2">
                    <Link
                      color="primary"
                      data-testid="store-pod-name"
                      height="snug"
                      variant="h5"
                      weight="bold"
                      href={`${store?.storeDetailsPageLink}${lcpMetricsQueryParam}`}
                    >
                      {`${index + 1} - ${store?.name} #${store?.storeId}`}
                    </Link>
                  </div>
                  <div className="sui-pt-2 sui-pb-2 sui-items-start sui-flex sui-justify-between">
                    <div data-component="StorePodAddress">
                      <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
                        <Typography height="tight">{store?.address?.street}</Typography>
                      </div>
                      <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
                        <Typography height="tight">{
                          `${store?.address?.city}, ${store?.address?.state} ${store?.address?.postalCode}`
                        }
                        </Typography>
                      </div>
                    </div>
                    <div className="sui-font-bold" data-component="StorePodDistance">
                      <span className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
                        <Typography height="tight" weight="bold">{`${store?.distance} mi`}</Typography>
                      </span>
                    </div>
                  </div>
                  <div className="sui-py-3">
                    <StoreHours hours={store?.storeHours} />
                  </div>
                  <div className="sui-flex sui-flex-col sui-gap-3">
                    <div className="sui-grid-cols-3" data-component="StorePodLink">
                      <Link
                        data-testid="store-pod-link__button"
                        height="tight"
                        href={`${store?.storeDetailsPageLink}/garden-center${lcpMetricsQueryParam}`}
                      >
                        View Garden Center
                      </Link>
                    </div>
                    <div className="sui-grid-cols-3" data-component="StorePodLink">
                      <Link
                        data-testid="store-pod-link__button"
                        height="tight"
                        href={`${store?.storeDetailsPageLink}/services${lcpMetricsQueryParam}`}
                      >
                        View Home Services
                      </Link>
                    </div>
                    <div className="sui-grid-cols-3" data-component="StorePodLink">
                      <Link
                        data-testid="store-pod-link__button"
                        height="tight"
                        href={`${store?.storeDetailsPageLink}/rentals${lcpMetricsQueryParam}`}
                      >
                        View Rentals
                      </Link>
                    </div>
                    <div className="sui-grid-cols-3" data-component="StorePodLink">
                      <Link
                        data-testid="store-pod-link__button"
                        height="tight"
                        href={`${store?.storeDetailsPageLink}/pro-desk${lcpMetricsQueryParam}`}
                      >
                        View Pro Desk
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};
const openCloseShape = shape({
  open: stringType(),
  close: stringType()
});

LocalCityStorePod.dataModel = {
  storeSearch: params({
    guid: stringType(),
    // lat and lng need to be declared for query to work
    lat: stringType(),
    lng: stringType(),
    radius: stringType(),
  }).shape(
    {
      stores: arrayOfType(shape({
        storeId: stringType(),
        name: stringType(),
        address: shape({
          street: stringType(),
          city: stringType(),
          state: stringType(),
          postalCode: stringType(),
          country: stringType()
        }),
        distance: stringType(),
        storeHours: shape({
          monday: openCloseShape,
          tuesday: openCloseShape,
          wednesday: openCloseShape,
          thursday: openCloseShape,
          friday: openCloseShape,
          saturday: openCloseShape,
          sunday: openCloseShape
        }),
        storeDetailsPageLink: stringType()
      })),
    }
  )
};